export default {
  title: 'Obraz reguły inteligentnej wyceny',
  select: {
    generate_title: 'Wygeneruj obraz za pomocą AI',
    generate_subtitle: 'Stworzymy go na podstawie Twojej reguły inteligentnej wyceny.',
    generate_cta: 'Generuj',
    upload_link: 'lub prześlij z urządzenia',
    rate_limit_company: {
      title: 'Potrzebujemy chwili',
      description: 'Twoja restauracja wygenerowała dużo obrazów w tej godzinie. Spróbuj ponownie za {{time}}.',
    },
    rate_limit_smart_pricing_rule: {
      title: 'Chwila przerwy',
      description: 'Wygląda na to, że próbowałeś tej reguły kilka razy z rzędu. Będziemy gotowi za {{time}}.',
    },
  },
  generating: {
    title: 'Generowanie obrazu…',
    progress: {
      cooking: 'Przygotowujemy coś pysznego…',
      plating: 'Dekorujemy…',
      finishing: 'Dodajemy ostatnie szlify…',
    },
  },
  preview: {
    alt: 'Wygenerowany obraz reguły inteligentnej wyceny',
    hint: 'Coś nie tak? Wygeneruj ponownie lub przejdź do kadrowania.',
    click_to_expand: 'Kliknij, aby powiększyć',
    regenerate: 'Wygeneruj ponownie',
    continue: 'Przejdź do edycji',
  },
  toasts: {
    upload_success: 'Obraz przesłany pomyślnie.',
    upload_failed: 'Nie udało się przesłać obrazu.',
    delete_success: 'Obraz usunięty pomyślnie.',
    delete_failed: 'Nie udało się usunąć obrazu.',
    generate_success: 'Obraz wygenerowany pomyślnie.',
    generate_failed: 'Nie udało się rozpocząć generowania obrazu.',
    generate_timeout: 'Obraz jest nadal generowany. Pojawi się tutaj, gdy będzie gotowy.',
    rate_limit_company: 'Osiągnięto godzinny limit obrazów dla tej restauracji. Spróbuj ponownie za {{time}}.',
    rate_limit_smart_pricing_rule: 'Zbyt wiele prób dla tej reguły — spróbuj ponownie za {{time}}.',
  },
  time: {
    seconds_one: '1 sekunda',
    seconds_few: '{{count}} sekundy',
    seconds_many: '{{count}} sekund',
    seconds_other: '{{count}} sekund',
    minutes_one: '1 minuta',
    minutes_few: '{{count}} minuty',
    minutes_many: '{{count}} minut',
    minutes_other: '{{count}} minut',
    hours_one: '1 godzina',
    hours_few: '{{count}} godziny',
    hours_many: '{{count}} godzin',
    hours_other: '{{count}} godzin',
  },
};
